// src/components/layout/MainLayout.js
import React from "react";
import { Box } from "@mui/material";
import { MyProSidebarProvider } from "../navigationbar/sidebarContext";

const MainLayout = ({ children }) => {
  return (
    <MyProSidebarProvider>
      <Box display="flex" height="auto" width="auto%">
        <Box flex={1} overflow="auto">
          {children}
        </Box>
      </Box>
    </MyProSidebarProvider>
  );
};

export default MainLayout;
